// import axiosInstance from './axiosInstance'; 

// const login = async (phoneNumber) => {
//     const response = await axiosInstance.post('/api/login', { phoneNumber });
//     const token = response.data.token;
//     localStorage.setItem('token', token);
//     return response;
// };


// const logout = async () => {
//     const token = localStorage.getItem('token');
//     if (!token) {
//         console.error('No token found in localStorage');
//         return;
//     }

//     try {
//         const response = await axiosInstance.post('/api/logout', {}, {            
//             headers: {
//                 Authorization: `Bearer ${token}`,
//                 'X-Requested-With': 'XMLHttpRequest',
//             },
//             withCredentials: true,
//         });
        
//         localStorage.removeItem('token');  
//         return response;      
//         // window.location.href = '/';
//     } catch (error) {
//         console.error('Error during logout:', error.response ? error.response.data : error.message);
//     }
// };

// const getUser = async (userId) => {
//     const token = localStorage.getItem('token');  

//     if (!token) {
//         throw new Error('No token found');
//     }
//     const response = await axiosInstance.get(`/api/user/${userId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//     });
//     return response.data;
// };

// export default { login, logout, getUser };

import { apiJson } from '../api/apiClient';

const jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

// All calls go through apiJson(tenant, ...) — the same tenant-aware
// request helper already used everywhere else in the app (UnitPage,
// ProjectsLayout, etc.) — so every auth call is correctly scoped to the
// tenant it was made under. This replaces the old axiosInstance-based
// login/logout/getUser, which hit a single shared apiUrl with no tenant
// info at all and were never actually wired into UnitPage's real flow.

const login = (tenant, { email, password }) =>
    apiJson(tenant, '/user/login', {
        method: 'POST',
        headers: jsonHeaders,
        body: JSON.stringify({ email, password }),
    });

const register = (tenant, formData) =>
    apiJson(tenant, '/user/register', {
        method: 'POST',
        headers: jsonHeaders,
        body: JSON.stringify(formData),
    });

const verifyEmail = (tenant, userId, otp) =>
    apiJson(tenant, '/user/verify-email', {
        method: 'POST',
        headers: jsonHeaders,
        body: JSON.stringify({ user_id: userId, otp }),
    });

const verifyPhone = (tenant, userId, otp) =>
    apiJson(tenant, '/user/verify-phone', {
        method: 'POST',
        headers: jsonHeaders,
        body: JSON.stringify({ user_id: userId, otp }),
    });

const resendOtp = (tenant, userId, type) =>
    apiJson(tenant, '/user/resend-otp', {
        method: 'POST',
        headers: jsonHeaders,
        body: JSON.stringify({ user_id: userId, type }),
    });

// No dedicated server-side logout/session-invalidation endpoint was visible
// in UnitPage's flow, so this just resolves — the token is discarded
// client-side by AuthContext. If your backend does have a token-revoke
// route, wire it in here (e.g. apiJson(tenant, '/user/logout', { method: 'POST', headers: { Authorization: `Bearer ${token}` } })).
const logout = async () => true;

export default { login, register, verifyEmail, verifyPhone, resendOtp, logout };
